import isMobile from "ismobilejs";
export default isMobile;
